<template>
    <form class="form-inline search" method="get" action="/search" autocomplete="off">
        <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search" name="search" v-model="searchTerm" @input="search" autocomplete="off">
        <div class="autocomplete" v-if="matches">
            <ul>
                <li v-for="match in matches"><a :href="match.url">{{ match.label }}</a></li>
            </ul>
        </div>
    </form>
</template>

<script>

    import _ from 'lodash';
    import {ServiceFactory} from '../../../../../shared/assets/js/services/ServiceFactory';

    const SearchService = ServiceFactory.get('search');

    export default {
        data() {
            return {
                searchTerm: '',
                matches: [],
            }
        },
        methods: {
            search: _.debounce(function () {
                if (this.searchTerm.length > 1) {
                    this.findMatches();
                } else if (!this.searchTerm.length) {
                    this.matches = [];
                }
            }, 100),

            async findMatches() {
                const result = await SearchService.get(this.searchTerm);
                this.matches = result.data;
            }


        }
    }
</script>
